// extracted by mini-css-extract-plugin
export default {"testimonial":"testimonial_testimonial__vaDuR"};